import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';
import MenuItem from 'material-ui/MenuItem';
import { ORDER_STATUS } from '../../constants';

class UpdateStatus extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired
  }

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);

    this.state = {
      value: null,
      showReceiver: false,
      pod: null
    }
  }

  handleChange(event, index, value) {
    if (value === ORDER_STATUS.DELIVERED.id) {
      this.setState({ value, showReceiver: true })
    } else {
      this.setState({ value, showReceiver: false, pod: null });
    }
  }

  handleSave() {
    const { value } = this.state;
    this.props.onConfirm(value, (this.pod) ? this.pod.getValue() : null);
    this.setState({ value: null });
  }

  render() {
    const { open, onClose } = this.props;
    const { showReceiver } = this.state;
    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onTouchTap={onClose}
      />,
      <FlatButton
        label="Save"
        primary={true}
        onTouchTap={this.handleSave}
      />,
    ];

    return (
      <Dialog
          title="Update Order Status"
          actions={actions}
          modal={false}
          open={open}
          onRequestClose={onClose}
        >
          <SelectField floatingLabelText="Status" onChange={this.handleChange} value={this.state.value}>
            <MenuItem value={ORDER_STATUS.PENDING.id} primaryText={ORDER_STATUS.PENDING.name} />
            <MenuItem value={ORDER_STATUS.READY.id} primaryText={ORDER_STATUS.READY.name} />
            <MenuItem value={ORDER_STATUS.EN_ROUTE.id} primaryText={ORDER_STATUS.EN_ROUTE.name} />
            <MenuItem value={ORDER_STATUS.AT_FACILITY.id} primaryText={ORDER_STATUS.AT_FACILITY.name} />
            <MenuItem value={ORDER_STATUS.DELIVERED.id} primaryText={ORDER_STATUS.DELIVERED.name} />
            <MenuItem value={ORDER_STATUS.TRAILERED.id} primaryText={ORDER_STATUS.TRAILERED.name} />
          </SelectField>
          {showReceiver &&
            <TextField id="pod" name="pod" ref={ref => this.pod = ref} floatingLabelText="POD (Name)" />
          }
        </Dialog>
    );
  }
}

export default UpdateStatus;


// WEBPACK FOOTER //
// ./src/containers/Modals/UpdateStatus.js